// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1995":"33cb215e","4594":"af8d951d","5678":"af8d951d"}[chunkId] + ".chunk.css");